import React from 'react';
import style from './index.scss';
import HeaderBanner from './../../common/HeaderBanner';

export const Card = () => (
    <div className={style.card}>
        <div className={style.media}/>
    </div>
);

export const Section = () => (
        <div className={style.container}>
            <div className={style.fixedContainer}>
                <div className={style.raceList}>
                    <div>
                        <HeaderBanner key={'bannerempty'} state={'empty'} text={'Empty'} useShape={true}/>
                        <div className={style.sliderContainer}>
                            <Card></Card>
                            <Card></Card>
                            <Card></Card>
                            <Card></Card>
                            <Card></Card>
                            <Card></Card>
                            <Card></Card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

export default () => (
    <div>
        <Section/>
        <Section/>
        <Section/>
        <Section/>
        <Section/>
    </div>
);
